const ITEMS = ["PREVENT THE HARM", "BREAK THE CYCLE", "SAVE LIVES", "NO TO METH — IT LEADS TO DEATH", "RECOVERY IS POSSIBLE", "#NOTOMETH", "#BREAKTHECYCLE", "#SAVELIVES"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative bg-[#EF4444] text-white overflow-hidden py-3 border-y border-black/20 -rotate-[0.5deg] scale-[1.01]" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="font-display font-extrabold uppercase tracking-tight text-sm sm:text-base whitespace-nowrap px-6 flex items-center gap-6">
            {item} <span className="opacity-50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
